import React from 'react';
import Main from './Main';
import { Provider } from 'mobx-react';
import stepStore from '../../../store/step';
import './style/index.less';

export default function () {
  return (
    <section className='settled-index'>
      {/* <header></header> */}
      <Provider stepStore={stepStore}>
        <Main />
      </Provider>
      {/* <div className='extra-mobile'>
        违法和不良信息公开举报电话：0571-86136192
      </div> */}
    </section>
  )
}

